import { createApiClient } from '@brightlocal/api-client';

import { getAccessToken } from './services';
import {
  buildSessionExpiredLoginUrl,
  createAuthMiddleware,
  handleSessionExpired,
  initTokenRefreshService,
  notifyIdentityChanged
} from './services/auth';
import { env, ENVIRONMENTS } from '../config/env';

const baseUrl = env.environment === ENVIRONMENTS.LOCAL ? '/api' : env.apiBaseUrl;

const baseConfig = {
  baseUrl,
  getToken: getAccessToken,
  middleware: {
    authMiddleware: createAuthMiddleware()
  }
};

const googlePlacesConfig = {
  baseUrl: 'https://places.googleapis.com/v1',
  apiKey: env.googleApiKey
};

/**
 * BrightLocal Data API Configuration
 * Uses '/data-api' proxy for local development to avoid CORS issues.
 */
const dataApiConfig = {
  baseUrl: env.environment === ENVIRONMENTS.LOCAL ? '/data-api' : env.dataApiBaseUrl,
  getToken: getAccessToken,
  middleware: {
    authMiddleware: createAuthMiddleware()
  }
};

export const apiClient = createApiClient(baseConfig, googlePlacesConfig, dataApiConfig);

initTokenRefreshService({
  refreshTokenApi: () => apiClient.auth.refreshAccessToken(),
  onSessionExpired: () => {
    const returnTo = window.location.pathname + window.location.search + window.location.hash;

    // Auth pages (sign-up, login, …) reload in place — the stale session is
    // discarded silently rather than bouncing the visitor to login with a
    // "session expired" toast and a `redirect` pointing back into `/auth/*`.
    void handleSessionExpired(buildSessionExpiredLoginUrl(returnTo));
  },
  onIdentityChanged: notifyIdentityChanged
});

export type ToolsApiClient = typeof apiClient;
